import { useAppContext, useClientContext } from "@data-root/react";
import { AppSpecifier, CoreProtocol, FormulaContext } from "@data-root/types";
import { useCallback, useEffect, useRef } from "react";

export const useService = (serviceId: string, context: FormulaContext) => {
  const { core } = useClientContext();
  const { appSpecifier } = useAppContext();

  const stopService = useRef<() => void>();

  const startService = useCallback(async () => {
    stopService.current = await core.startService(
      appSpecifier,
      serviceId,
      context
    );
  }, [appSpecifier, context, core, serviceId]);

  useEffect(() => {
    startService();

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      stopService.current?.();
    };
  }, [startService]);
};

export const useServices = (
  services: string[] | undefined,
  context: FormulaContext
) => {
  const { core } = useClientContext();
  const { appSpecifier } = useAppContext();

  const stopServices = useRef<(() => void)[]>([]);

  const startServices = useCallback(async () => {
    if (!services) return;

    stopServices.current = await Promise.all(
      services.map((serviceId) =>
        core.startService(appSpecifier, serviceId, context)
      )
    );
  }, [appSpecifier, context, core, services]);

  useEffect(() => {
    startServices();

    return () => {
      stopServices.current.forEach((stop) => stop());
    };
  }, [startServices]);
};
